export enum EditorMode {
  Component = 'Components',
  SUA = 'SUA',
  UnitOperation = 'UnitOperation',
  Reference = 'Reference',
}
